import React from 'react'
import classes from './DutyTableRows.module.css'
import { Table, Tbody, Thead, Tr, Th, Text, Td, Heading } from '@chakra-ui/react'
import DutyCell from '../DutyCell/DutyCell'
import { useDutyStore } from '../../store/dutyStore'
import { getWeekDateList } from '../../utils/dutyHelper'

function DutyTableRows({week}) {
    const duty = useDutyStore(state => state.duty)
    const weekDateList = getWeekDateList(duty?.weeks, week)

    const getRowTime = (row) => {
        for (let time of row)
            if (time !== null)
                return <>
                    <Text align='center' fontWeight='bold'>{`${time.start_time}`}</Text>
                    <Text align='center'>-</Text>
                    <Text align='center' fontWeight='bold'>{`${time.end_time}`}</Text>
                </>
        return <></>
    }

    return (
        duty && duty?.weeks?.length > 0 && duty?.weeks?.length > week
        ?
        <div className={classes.container}>
            <Table>
                <Thead>
                    <Tr>
                        <Th className={classes.timeHead}>
                            Время
                        </Th>
                        <Th>
                            Понедельник
                            <p>{weekDateList[0]}</p>
                        </Th>
                        <Th>
                            Вторник
                            <p>{weekDateList[1]}</p>
                        </Th>
                        <Th>
                            Среда
                            <p>{weekDateList[2]}</p>
                        </Th>
                        <Th>
                            Четверг
                            <p>{weekDateList[3]}</p>
                        </Th>
                        <Th>
                            Пятница
                            <p>{weekDateList[4]}</p>
                        </Th>
                        <Th>
                            Суббота
                            <p>{weekDateList[5]}</p>
                        </Th>
                        <Th>
                            Воскресенье
                            <p>{weekDateList[6]}</p>
                        </Th>
                    </Tr>
                </Thead>
                <Tbody>
                    {duty.weeks[week].rows.map((row, rowIndex) => 
                        <Tr key={`row${rowIndex}`}>
                            <Td className={classes.time}>
                                {getRowTime(row)}
                            </Td>
                            {row.map((time, timeIndex) => 
                            <Td key={`time${rowIndex}${timeIndex}`}>
                                {
                                time &&
                                <DutyCell time={time} key={`time${time.time_id}`} />
                                }
                            </Td>
                            )}
                        </Tr>
                    )}
                </Tbody>
            </Table>
        </div>
        :
        <Heading>Ошибка при загрузке расписания</Heading>
    )
}

export default DutyTableRows
